<template>
  <div class="signout"></div>
</template>

<script>
export default {
  name: "Signout",
  async created() {
      await this.signOut();
  },
  methods: {
    async signOut() {
      try {
        await this.axios.get("https://auth.tactint.com/auth/v3b4/logout");
        this.$store.commit("setUser", { user: null });
        this.$router.push({ name: "login" });
      } catch (e) {
        if (e.response && e.response.status === 500)
          this.$router.push({ name: "error" });
        //console.log(e.response);
      }
    }
  }
};
</script>
